import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/users')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('users:list')) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/users/pages/users-settings-page')),
  staticData: { titleKey: 'users' },
});
